// src/ErrorBoundary.jsx
// App-wide error boundary. Catches render-time crashes anywhere below it so the
// user sees a recoverable fallback instead of a blank white screen, and reports
// the error to Sentry when error tracking is enabled (no-op otherwise).

import React from 'react'
import { Sentry, sentryEnabled } from './lib/sentry'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    if (sentryEnabled) {
      Sentry.captureException(error, { extra: { componentStack: info?.componentStack } })
    } else {
      // eslint-disable-next-line no-console
      console.error('[ErrorBoundary]', error, info?.componentStack)
    }
  }

  handleReload = () => {
    // Full reload is the safest reset for an unknown render crash.
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          textAlign: 'center',
          fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
        }}
      >
        <div style={{ maxWidth: 420 }}>
          <h1 style={{ fontSize: 20, marginBottom: 8 }}>Terjadi kesalahan</h1>
          <p style={{ color: '#666', marginBottom: 20, lineHeight: 1.5 }}>
            Maaf, ada yang tidak beres saat memuat halaman ini. Coba muat ulang —
            jika masalah berlanjut, hubungi admin.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: '10px 20px',
              borderRadius: 8,
              border: 'none',
              background: '#1a1a1a',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Muat ulang halaman
          </button>
        </div>
      </div>
    )
  }
}
